<template>
  <el-dialog
    width="35%"
    title="新增"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="90px">
      <el-form-item label="区域名称" prop="districtName" v-if="type == 2">
        <el-input v-model="dataForm.districtName" placeholder="区域名称" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="工种名称" prop="districtName" v-if="type == 1">
        <el-input v-model="dataForm.professionName" placeholder="工种名称" maxlength="100"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { districtSave, professionSave } from "../api";
  export default {
    data () {
      return {
        visible: false,
        type: '',
        dataForm: {
          districtName: '',
          professionName:''
        },
      }
    },
    methods: {
      init (type) {
        this.visible = true; 
        this.type = type;
        this.dataForm.districtName = '';
        this.dataForm.professionName = '';
      },
      // 表单提交
      dataFormSubmit () {
        if(this.type == 2){
          if(!this.dataForm.districtName){
            return this.$message.error('请填区域名！');
          }
          districtSave({
            'districtName': this.dataForm.districtName
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList');
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          }) 
        }else if(this.type == 1){
          if(!this.dataForm.professionName){
            return this.$message.error('请填工种名称！');
          }
          professionSave({
            'professionName': this.dataForm.professionName
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshTypeList');
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          }) 
        }
      }
    }
  }
</script>
